import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  CardTitle,
  CardSubtitle,
  Label,
  Input,
  Container,
  FormFeedback,
  Form,
  InputGroup,
} from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/BreadcrumbBack"

//i18n
import { withTranslation } from "react-i18next"

//redux
import {
  getBrand as onGet,
  clearBrand as onClear,
  updateBrand as onSave,
  deleteBrand as onDelete,
  brandsResetError as onClearError,
} from "store/actions"
import { useDispatch, useSelector } from "react-redux"

//Custom CSS
import "./custom.scss"
import moment from "moment"
import Swal from "sweetalert2"
import { Link } from "react-router-dom"
import * as Yup from "yup"
import { useFormik } from "formik"

import { isEmpty } from "lodash"
import Loading from "components/Common/Loading"
import Dropzone from "react-dropzone"

const BrandEdit = props => {
  //meta title
  document.title = props.t("Edit Brand")

  const dispatch = useDispatch()
  const { error, loading, brand } = useSelector(state => ({
    error: state.Brands?.error,
    loading: state.Brands?.loading || false,
    brand: state.Brands?.brand,
  }))

  const [data, setData] = useState(null)
  const [selectedFiles, setselectedFiles] = useState([])
  const IMAGE_BASE = process.env.REACT_APP_IMAGE_BASE
  const breadcrumbItems = [
    { title: props.t("Brands"), link: "/v1/brands" },
    { title: props.t("Edit Brand"), link: "#" },
  ]

  const {
    match: { params },
  } = props

  useEffect(() => {
    if (!isEmpty(error)) {
      console.error("error", error)
      Swal.fire(
        props.t("Error"),
        error?.error || error?.message || JSON.stringify(error),
        "error"
      )
      dispatch(onClearError())
    }
  }, [error])

  useEffect(() => {
    if (params.id) {
      if (isEmpty(brand) && isEmpty(data)) {
        dispatch(onGet(params.id))
      } else if (!isEmpty(brand) && isEmpty(data)) {
        const temp_data = { ...brand }
        setData(temp_data)
        for (let key of Object.keys(validation.values)) {
          try {
            validation.setFieldValue(key, temp_data[key])
          } catch (err) {
            console.error("key converter failed", key, err)
          }
        }
        console.log("temp_data", temp_data)

        if (temp_data.image) {
          let fName = temp_data.image
          let formatArr = temp_data.image.split(".")
          console.log("formatArr", formatArr)
          let format = formatArr[formatArr.length - 1]
          setselectedFiles([
            {
              path: temp_data.image,
              preview: IMAGE_BASE + temp_data.image,
              name: temp_data.image,
              type: "image/" + format,
              formattedSize: "..",
            },
          ])
        }
        setTimeout(() => {
          dispatch(onClear())
        }, 300)
      }
    }
  }, [brand])

  function handleAcceptedFiles(files) {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    )
    setselectedFiles(files)
  }

  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

  // Form validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name: "",
      description: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required(props.t("Required")),
      description: Yup.string(),
    }),
    onSubmit: values => {
      console.log("values", values)
      let tempSelectedFiles = []
      if (selectedFiles.length > 0) {
        if (selectedFiles[0].name != values.image) {
          tempSelectedFiles = selectedFiles
        }
      }
      console.log("tempSelectedFiles", tempSelectedFiles)
      console.log("params.id, values, tempSelectedFiles", params.id, values, tempSelectedFiles)
      dispatch(onSave(params.id, values, tempSelectedFiles, props.history)) 
    },
  })

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Brand")}
            backLink={"/v1/brands"}
            breadcrumbItems={breadcrumbItems}
          />
          <Loading status={loading} />
          <Row>
            <Col md={6}>
              <Card>
                <CardBody>
                  <h4 className="card-title">{props.t("Edit Brand")}</h4>
                  <p className="card-title-desc">
                    {props.t("Edit Brand Description")}
                  </p>
                  <Form
                    className="needs-validation"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Col md="12">
                        <FormGroup className="mb-3">
                          <Label htmlFor="name">{props.t("BrandName")}</Label>
                          <Input
                            name="name"
                            placeholder={props.t("BrandName")}
                            type="text"
                            className="form-control"
                            id="name"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.name || ""}
                            invalid={
                              validation.touched.name && validation.errors.name
                                ? true
                                : false
                            }
                          />
                          {validation.touched.name && validation.errors.name ? (
                            <FormFeedback type="invalid">
                              {validation.errors.name}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col md="12">
                        <FormGroup className="mb-3">
                          <Label htmlFor="description">
                            {props.t("Description")}
                          </Label>
                          <Input
                            name="description"
                            placeholder={props.t("Description")}
                            type="textarea"
                            rows="3"
                            className="form-control"
                            id="description"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.description || ""}
                            invalid={
                              validation.touched.description &&
                              validation.errors.description
                                ? true
                                : false
                            }
                          />
                          {validation.touched.description &&
                          validation.errors.description ? (
                            <FormFeedback type="invalid">
                              {validation.errors.description}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                    </Row>

                    <Button color="primary" type="submit">
                      {props.t("Save")}
                    </Button>
                    <Button
                      color="danger"
                      className="ms-2"
                      onClick={() => {
                        Swal.fire({
                          title: props.t("Are You Sure"),
                          text: props.t("DeleteWarning"),
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#3085d6",
                          cancelButtonColor: "#d33",
                          confirmButtonText: props.t("Yes, delete it!"),
                          cancelButtonText: props.t("Cancel"),
                        }).then(result => {
                          if (result.isConfirmed) {
                            dispatch(onDelete(params.id, props.history))
                          }
                        })
                      }}
                    >
                      {props.t("Delete")}
                    </Button>
                  </Form>
                </CardBody>
              </Card>
            </Col>
            <Col md="6" className="mb-3">
              <Row className="relative">
                <Dropzone
                  multiple={false}
                  onDrop={acceptedFiles => {
                    handleAcceptedFiles(acceptedFiles)
                  }}
                >
                  {({ getRootProps, getInputProps }) => (
                    <div className="dropzone">
                      <div
                        className="dz-message needsclick mt-2"
                        {...getRootProps()}
                      >
                        <input {...getInputProps()} />
                        <div className="mb-3">
                          <i className="display-4 text-muted bx bxs-cloud-upload" />
                        </div>
                        <h4>{props.t("Campaign Image Drop here")}</h4>
                        <h5>{props.t("Max Size")} 2 MB</h5>
                      </div>
                    </div>
                  )}
                </Dropzone>
                {!isEmpty(selectedFiles) ? (
                  <div className="dropzone-previews" id="file-previews">
                    {selectedFiles.map((f, i) => {
                      return (
                        <Card
                          className="mb-0 shadow-none border-dashed dz-processing dz-image-preview dz-success dz-complete"
                          key={i + "-file"}
                        >
                          <div className="p-2">
                            <Row className="align-items-center">
                              <Col className="text-end">
                                <img alt={f.name} src={f.preview} />
                                <Col>
                                  <Link
                                    to="#"
                                    className="text-muted font-weight-bold"
                                  >
                                    {f.name}
                                  </Link>
                                  <p className="mb-0">
                                    <strong>{f.formattedSize}</strong>
                                  </p>
                                </Col>
                              </Col>
                            </Row>
                          </div>
                        </Card>
                      )
                    })}
                    <div
                      className="dropzone-close"
                      onClick={() => {
                        validation.setFieldValue("image", null)
                        setselectedFiles([])
                      }}
                    >
                      <img />
                    </div>
                  </div>
                ) : null}
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

BrandEdit.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
}

export default withTranslation()(BrandEdit)
